<template>
    <v-row>
        <v-col cols="12" v-if="pagos.length > 0">
            <v-row>
                <!-- <v-col cols="2" sm="6" md="2">
                    <v-btn block color="red" class="mt-2 mr-2 white--text font-weight-bold">
                        <v-icon left>fas fa-exclamation-triangle</v-icon>
                            <span class="font-weight-bold text-h6">  [ {{ pagos.length }} ]  </span>
                            Pagos pendientes
                        <v-icon right>fas fa-exclamation-triangle</v-icon>
                    </v-btn>
                </v-col> -->
                <v-col sm="6" xs="12" md="4" class="order-1">
                    <v-btn block color="green" class="white--text font-weight-bold" small raised elevation="4">
                        Seleccionado: <span class="font-weight-bold text-h6"> {{ getTotalSaldoSelectedNatural }} </span>
                        <v-icon right @click.prevent="copyClipboardSaldoSelected(getTotalSaldoSelectedNatural)">fas
                            fa-copy</v-icon>
                    </v-btn>
                </v-col>
                <v-col sm="6" xs="12" md="8" class="d-flex justify-end order-2">
                    <v-btn color="orange" class="mr-2" @click.prevent="enableAll()" small raised elevation="4">
                        <v-icon left>fas fa-check-square</v-icon> Habilitar todos
                    </v-btn>
                    <v-btn color="primary" @click.prevent="asignarPagos()" small raised elevation="4">
                        <v-icon left>fas fa-dollar-sign</v-icon> Autoasignar pagos
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12">
            <v-simple-table fixed-header height="auto" dense class="elevation-1">
                <template v-slot:default>
                    <thead class="text-left teal darken-4 font-weight-bold">
                        <tr class="font-weight-bold">
                            <th class="text-left p-0">Habilitar</th>
                            <th class="text-left p-0">Folio venta</th>
                            <th class="text-left p-0">Fecha venta</th>
                            <th class="text-left p-0">Total</th>
                            <th class="text-left p-0">Abonado</th>
                            <th class="text-left p-0">Saldo</th>
                            <th class="text-left p-0">Monto a Pagar</th>
                            <!-- <th class="text-left p-0">Acciones</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in pagos" :key="item.id" v-if="pagos.length > 0">
                            <td>
                                <v-row class="container fluid">
                                    <v-checkbox v-model="item.activo"></v-checkbox>
                                </v-row>
                            </td>
                            <td>
                                <v-row>
                                    <v-col cols="auto">
                                        <span class="text-left font-weight-bold mx-1 success--text text--darken-2 rounded ">
                                            {{ item.ticketFolio }}
                                            <br>
                                            <p class="text-left font-weight-bold text-h7 tag-employee"
                                                v-if="item.employeeName != ''">
                                                <v-icon x-small left color="white">fas fa-user</v-icon>{{ item.employeeName }}
                                            </p>
                                            <p class="text-left font-weight-bold text-h7 tag-employee"
                                                v-if="item.clientSucursalName != ''">
                                                <v-icon x-small left color="white">fas fa-building</v-icon>{{ item.clientSucursalName }}
                                            </p>
                                        </span>
                                    </v-col>
                                </v-row>
                                    <!-- <v-chip small class="p-1 text-primary font-weight-bold text-no-wrap" color="primary" text-color="green" outlined label>
                                        <v-icon x-small left>fas fa-hashtag</v-icon>
                                        {{ item.ticketFolio }}
                                    </v-chip>  -->
                                <!-- <v-chip small class="p-1 ma-1" color="secondary" text-color="white" v-if="item.employeeName != ''">
                                    <v-icon x-small left>fas fa-user</v-icon>
                                    {{ item.employeeName }}
                                </v-chip> -->
                            </td>
                            <td>
                                <h4 class="text-left font-weight-bold info--text text--darken-2">
                                {{ item.registerDate }}
                                </h4>
                            </td>
                            <td>
                                <v-text-field :value="item.totalNatural" type="text"
                                    class="font-weight-bold green--text d-flex justify-end text-h6" persistent-hint
                                    disabled>
                                </v-text-field>
                            </td>
                            <td>
                                <v-text-field :value="item.abonadoNatural" type="text"
                                    class="font-weight-medium text-h6 green--text" persistent-hint disabled>
                                </v-text-field>
                            </td>
                            <td>
                                <v-text-field :value="item.saldoNatural" type="text"
                                    class="font-weight-medium text-h6 green--text" persistent-hint disabled>
                                </v-text-field>
                            </td>
                            <td>
                                <ValidationProvider
                                    :rules="!item.activo ? '' : 'required|min_value:0.01|max_value:' + item.saldo+'' "
                                    v-slot="{ errors, valid }" :immediate="true">
                                    <v-text-field v-model.number="item.payedAmount" :value="item.payedAmount"
                                        type="number" class="mt-2 font-weight-black text-h6" outlined persistent-hint
                                        required min="1" :max="item.saldo" placeholder="0.00" :error-messages="errors"
                                        :success="valid" :disabled="!item.activo">
                                        <!-- @input="(e) => changeItem(e, index, 'cantidad')" -->
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <!-- <td>
                                <v-row align="center" justify="center" class="mb-1">
                                    <span class="group pa-1">
                                        <v-icon medium class="mx-1 pa-1" left color="red darken-1" @click="deletePayment(item, index)">fas fa-trash-alt</v-icon>
                                    </span>
                                </v-row>
                            </td> -->
                        </tr>
                        <tr v-if="pagos.length == 0">
                            <td colspan="8">
                                <v-alert block border="left" colored-border type="success" elevation="2" text dense
                                    class=" mt-1 green--text font-weight-bold text-h5 text-center">
                                    {{
                                    (pago.clienteId == 0 || pago.clienteId == null)
                                    ? 'Favor de seleccionar un cliente para la consulta de pagos'
                                    : 'El cliente no tiene deudas pendientes'
                                    }}
                                </v-alert>
                            </td>
                        </tr>
                        <tr v-else>
                            <td colspan="2"></td>
                            <td colspan="3">
                                <v-alert border="right" colored-border elevation="2" outlined text dense
                                    class=" mt-2 green--text font-weight-bold text-h5 text-center">
                                    Total a cobrar:
                                </v-alert>
                            </td>
                            <td colspan="2">
                                <v-alert border="right" colored-border elevation="2" outlined text dense
                                    class=" mt-2 green--text font-weight-bold text-h5 text-center">
                                    {{ getPayedAmountTotalNatural }}
                                </v-alert>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>
<script>
import VentaDataService from '@/service/venta/VentaDataService';
import { getFormatCurrency } from '@/utils/CurrencyUtil';

export default {
    name: 'AddPayment',
    props: {
        pago: { type: Object, required: true }
    },
    data() {
        return {
            pagos: [],
            deudas: []
        }
    },
    methods: {
        getVentaClient(clientId) {
            VentaDataService.findByCreditClient(clientId).then(response => {
                const info = response.data;
                this.deudas = info;
                this.pagos = info.map(item => {
                    return {
                        ...item,
                        clientId,
                        ventaId: item.id,
                        payedAmount: 0,
                        activo: false,
                    }
                });
            })
        },
        deletePayment(item, index) {
        },
        asignarPagos() {
            let amount = this.pago.payedAmount;
            // set payedAmount to 0
            this.pagos.forEach(item => item.payedAmount = 0);
            this.pagos.filter(payment => payment.activo == true).forEach(payment => {
                if(amount == 0){
                    payment.payedAmount = 0;
                    payment.activo = false;
                }
                if(amount > payment.saldo){
                    payment.payedAmount = payment.saldo;
                    amount = amount - payment.saldo;
                } else {
                    payment.payedAmount = amount;
                    amount = 0;
                }
            })
        },
        enableAll() {
            this.pagos.forEach(item => item.activo = true)
        },
        copyClipboardSaldoSelected(value) {
            if(!value) return;
            navigator.clipboard.writeText(value);
        }
    },
    watch: {
        'pago.clientId': function(newValue) {
            if (newValue != null) {
                this.getVentaClient(newValue)
            }
        },
        'pagos': function(newValue) {
            this.$emit('addPagos', newValue)
        }
    },
    computed: {
        getPayedAmountTotal() {
            const payments = this.pago.payments.filter(payment => payment.activo == true );
            return payments.reduce((total, payment) => total + payment.payedAmount, 0);
        },
        getPayedAmountTotalNatural() {
            return getFormatCurrency(this.getPayedAmountTotal, '$ ');
        },
        getTotalAcccount(){
            const total = this.pagos.reduce((acc, item) => acc + item.total, 0);
            return getFormatCurrency(total, '$ ');
        },
        getTotalAbonadoNatural(){
            const total = this.pagos.reduce((acc, item) => acc + item.abonado, 0);
            return getFormatCurrency(total, '$ ');
        },
        getTotalSaldoNatural(){
            const total = this.pagos.reduce((acc, item) => acc + item.saldo, 0);
            return getFormatCurrency(total, '$ ');
        },
        getTotalSaldoSelectedNatural(){
            const total = this.pagos.filter(payment => payment.activo == true).reduce((acc, item) => acc + item.saldo, 0);
            return getFormatCurrency(total, '$ ');
        }
    }
}
</script>
<style scoped>
    .tag-employee{
        border-radius: 10px;
        border: 2px solid rgba(0, 0, 0, 0.2);
        padding: 3px;
        margin-top: 2px;
        background: #424242;
        color: #d3d3d3;
        /*display: inline-flex;*/
        width: min-content;
        min-width: 120%;
    }
</style>